import ContentPage from './ContentPages';

const PurposeAndGuidelines = () => <ContentPage slug='purpose-and-community-guidelines' />;

export default PurposeAndGuidelines;
